const buildProAccountObject = (acc, instantCheckoutFlag) => {
    const preparedAccount = Object.assign({}, acc);
    preparedAccount.account.profile.enableInstantCheckout = instantCheckoutFlag;
    delete preparedAccount.account.profile.emailId;
    return preparedAccount;
};
const buildNonProAccountObject = (acc, instantCheckoutFlag) => {
    return {
        account: {
            customerAccountId: acc.account.customerAccountId,
            profile: {
                zipCode: acc.account.profile.zipCode,
                lastModifiedDate: acc.account.profile.lastModifiedDate,
                enableInstantCheckout: instantCheckoutFlag,
                name: {
                    firstName: !acc.account.profile.name
                        ? ''
                        : acc.account.profile.name.firstName,
                    lastName: !acc.account.profile.name
                        ? ''
                        : acc.account.profile.name.lastName,
                },
            },
            lastModifiedDate: acc.account.lastModifiedDate,
        },
    };
};
export const checkForLoyaltyAndBuildAccountObject = (acc, instantCheckoutFlag) => {
    const isLoyaltyEnrolled = acc.account.profile.loyaltyEnrollmentIndicator === 'Y';
    return isLoyaltyEnrolled
        ? buildProAccountObject(acc, instantCheckoutFlag)
        : buildNonProAccountObject(acc, instantCheckoutFlag);
};
